import { createBrowserRouter, RouterProvider, Navigate } from 'react-router-dom';
import { DashboardLayout } from '../layouts/DashboardLayout';
import { DashboardPage } from '../pages/dashboard/DashboardPage';
import { DocumentsPage } from '../pages/documents/DocumentsPage';
import { PlaygroundPage } from '../pages/playground/PlaygroundPage';
import SecurityPage from '../pages/SecurityPage';
import { LoginPage } from '../pages/login/LoginPage';
import { ProtectedRoute } from '../components/ProtectedRoute';
import { useAuth } from '../utils/authcontextt';
import Handoffpage from '../pages/handoff/handoffpage';
import { MailFailuresPage } from '../pages/mailfailures/MailFailuresPage';
import { SessionsPage } from '../pages/sessions/SessionsPage';
import { AnalyticsPage } from '../pages/analytics/AnalyticsPage';
import { FeedbackQueuePage } from '../pages/feedback/FeedbackQueuePage';
import { FeedbackDetailPage } from '../pages/feedback/FeedbackDetailPage';
import { AgentsPage } from '../pages/agents/AgentsPage';
import { UsersPage } from '../pages/users/UsersPage';
import { WeeklyReportPage } from 'pages/weeklyreport/weekly-reportPage';
import { AnnouncementsPage } from 'pages/announcements/AnnouncementsPage';
import { DataQaPage } from 'pages/data-qa/DataQaPage';

function RootRedirect() {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-600"></div>
      </div>
    );
  }

  return user ? <Navigate to="/dashboard" replace /> : <Navigate to="/login" replace />;
}

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootRedirect />,
  },
  {
    path: '/login',
    element: <LoginPage />,
  },
  {
    path: '/dashboard',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <DashboardPage />,
      },
    ],
  },
  {
    path: '/documents',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <DocumentsPage />,
      },
    ],
  },
  {
    path: '/kampanjer',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [{ index: true, element: <AnnouncementsPage /> }],
  },
  {
    path: '/playground',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <PlaygroundPage />,
      },
    ],
  },
  {
    path: '/handoff',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <Handoffpage />,
      },
    ],
  },
  {
    path: '/fastnade-mejl',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <MailFailuresPage />,
      },
    ],
  },
  {
    path: '/security',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <SecurityPage />,
      },
    ],
  },
  {
    path: '/sessions',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <SessionsPage />,
      },
    ],
  },
  {
    path: '/analytics',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <AnalyticsPage />,
      },
    ],
  },
  {
    path: '/feedback',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <FeedbackQueuePage />,
      },
      {
        path: ':id',
        element: <FeedbackDetailPage />,
      },
    ],
  },
  {
    path: '/agenter',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <AgentsPage />,
      },
    ],
  },
  {
    path: '/anvandare',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <UsersPage />,
      },
    ],
  },
  {
    path: '/data-qa',
    element: (
      <ProtectedRoute requireAdmin>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [{ index: true, element: <DataQaPage /> }],
  },
  {
    path: '/veckorapport',
    element: (
      <ProtectedRoute>
        <DashboardLayout />
      </ProtectedRoute>
    ),
    children: [
      {
        index: true,
        element: <WeeklyReportPage />,
      },
    ],
  },
]);

export const AppRouter = () => {
  return <RouterProvider router={router} />;
};
